import { formatPercentage } from '../../../packages/utils/numberFormatters'

export const valueFormatter = (locale: string) => (value: number) => formatPercentage(value, { locale, decimals: 1 })
